<template>
    <div class="item">
        <div class="Top">
            <div class="info">
                <div class="left" @click.stop="gotoExpertDetail">
                    <img :src="item.headPortrait || item.HEAD_PORTRAIT"  class="avatar"/>
                </div>
                <div class="right">
                    <div class="right-top">
                        <div class="name">
                            {{item.expertsNickName || item.EXPERTS_NICK_NAME}}
                        </div>
                        <div class="lable1" v-if="item.label1">
                            {{item.label1}}
                        </div>
                        <div class="lable2" v-if="item.label2">
                            {{item.label2}}
                        </div>
                    </div>
                    <div class="alias">
                        {{item.expertDes}}
                    </div>
                </div>
            </div>
            <div class="reto" v-if="item.hitRate&&item.hitRate !== ''&&item.hitRate!=='0'">
                <div class="reto-top">
                    <div class="num">
                        {{item.hitRate}}
                    </div>
                    <div class="fh">
                        %
                    </div>
                </div>
                <div class="text">
                   命中率
                </div>
            </div>
        </div>
        <div class="desc">
            {{ item.title || item.RECOMMEND_TITLE }}
        </div>
        <div class="matchInfo">
            <div v-if="item.matchList">
                <template v-if="item.lyClassCode === '201'">
                    <div class="matchs" v-for="(item2,i2) in item.matchList" :key="i2">
                        <div class="match">
                            <text class="tag">{{ item.orderType }}</text>
                            {{ item2.matchDateTime }}
                            {{ item2.leagueName }}
                            {{ item2.homeName }}
                            VS
                            {{ item2.awayName }}
                        </div>
                    </div>
                </template>
                
                <template v-else-if="item.lyClassCode === '204'">
                    <div class="matchs">
                        <div class="match">
                            <text class="tag">{{ item.orderType }}</text>
                            {{ item.matchList[0].matchDateTime }}
                            {{ item.matchList[0].leagueName }}
                            {{ item.matchList[0].awayName }}
                            VS
                            {{ item.matchList[0].homeName }}
                        </div>
                    </div>
                </template>
                
                
                <div class="matchs" v-else>
                    <div class="match">
                        <text class="tag">{{ item.orderType }}</text>
                        {{ item.matchList[0].matchDateTime }}
                        {{ item.matchList[0].leagueName }}
                        {{ item.matchList[0].homeName }}
                        VS
                        {{ item.matchList[0].awayName }}
                    </div>
                </div>
            </div>
            <div v-else>
                <template v-if="item.lyClassCode === '113'||item.lyClassCode === '001'||item.lyClassCode === '002'||item.lyClassCode === '108'">
                    <div class="matchs">
                        <div class="numMatch">
                            <text class="tag">{{ item.orderType }}</text>
                            <div class="right">
                                <div class="issue">
                                    {{item.issue}}期
                                </div>
                                <div class="time">
                                    截期时间 {{item.closeTime}}
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- 为关注列表展示用 -->
                <template v-if="item.LEAGUE_NAME">
                    <div class="matchs">
                        <div class="match">
                            <text class="tag">{{ item.orderType }}</text>
                            {{ item.MATCH_TIME }}
                            {{ item.LEAGUE_NAME }}
                            {{ item.AWAY_NAME }}
                            VS
                            {{ item.HOME_NAME }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="xrzw" v-if="item.firstOrderDes==='首单不中退'&&item.buyStatus === '0'&&item.closeStatus === '1'"></div>
        <div class="xrjg" v-if="item.firstOrderDes==='首单不中退'&&item.buyStatus === '0'&&item.closeStatus === '1'">
            <div class="left">
                {{ item.dateBefore || item.DATE_BEFORE }}
            </div>
            <div class="right">
                <div class="text">
                    新人
                </div>
                <div class="num">
                    3
                </div>
                <div class="text">
                    球币
                </div>
                <div class="oldyuan">
                    {{item.initPrice}}球币
                </div>
            </div>
        </div>
        <div class="Bottom" v-else>
            <div class="time">
                {{ item.dateBefore || item.DATE_BEFORE }}
            </div>
            <div class="priceBox" v-if="code!=='1008'&&code!=='1006'">
                <template v-if="item.buyStatus !== '0' || item.closeStatus !== '1'">
                    <text class="seediv">查看</text>
                </template>
                <template v-else>
                    <div class="price">
                        {{item.prize || item.PRICE}}球币
                    </div>
                    <div class="fenge" v-if="item.firstOrderDes"></div>
                    <div class="tip" v-if="item.firstOrderDes">
                        {{item.firstOrderDes}}
                    </div>
                </template>
            </div>
            <div class="priceBox" v-if="code==='1006'">
                <template v-if="item.buyStatus !== '0' || item.closeStatus !== '1'">
                    <text class="seediv">查看</text>
                </template>
                <div class="price" v-else>
                    限免
                </div>
            </div>
            <div class="priceBox" v-if="code==='1008'">
                <template v-if="item.buyStatus !== '0' || item.closeStatus !== '1'">
                    <text class="seediv">查看</text>
                </template>
                <template v-else>
                    <div class="price">
                        {{item.prize || item.PRICE}}球币
                    </div>
                    <div class="VIPStyle">
                        <img v-if="item.vipMissOut === '1'" src="https://www.fkhongdan.com/baiduxcx/static/zjtj/vipTip.png" mode="" />
                        <span>
                            {{ item.vipMissOut === '1' ? '不中退' : item.firstOrderDes }}
                        </span>
                    </div>
                </template>
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:"plan-card-sell",
        props:['item','code','vip'],
        data() {
            return {
                
            };
        },
        mounted(){
        },
        methods:{
            
            gotoExpertDetail(){
                window.parent.postMessage('expert'+(this.item.expertsName || this.item.EXPERTS_NAME),'*')
            }
        }
    }
</script>

<style lang="less" scoped>
    .item{
        position: relative;
        border-top: 1px solid #f4f4f4;
        box-sizing: border-box;
        width: 100%;
        background: #FFFFFF;
        padding: .12rem;
        
        .Top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .info{
                display: flex;
                align-items: center;
                .left{
                    .avatar{
                        width: .4rem;
                        height: .4rem;
                        border-radius: 50%;
                    }
                }
                .right{
                    margin-left: .08rem;
                    .right-top{
                        display: flex;
                        align-items: center;
                        .name{
                            font-size: .16rem;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #333333;
                            line-height: .22rem;
                        }
                        .lable1{
                            margin-left: .08rem;
                            padding: .01rem .02rem;
                            background-color: #FBF6F6;
                            font-size: .1rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #F64646;
                            line-height: .14rem;
                            border-radius: .02rem;
                        }
                        .lable2{
                            margin-left:.04rem;
                            padding: .01rem .02rem;
                            background-color: #F2F9FF;
                            font-size: .1rem;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #2E7BFE;
                            line-height: .14rem;
                            border-radius: .02rem;
                        }
                    }
                
                    .alias{
                        margin-top: .02rem;
                        font-size: .11rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: .16rem;
                    }
                }
               
            }
            
            .reto{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .reto-top{
                    display: flex;
                    align-items: flex-start;
                    .num{
                        font-size: .37rem;
                        font-family: HarmonyOS_Sans_SC_Bold;
                        color: #F64646;
                        line-height: .45rem;
                    }
                    .fh{
                        font-size: .11rem;
                        font-family: HarmonyOS_Sans_SC;
                        color: #F64646;
                        line-height: .27rem;
                    }
                }
                .text{
                    margin-top: -0.05rem;
                    font-size: .1rem;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #F64646;
                    line-height: .14rem;
                }
            }
        }
    
        .desc{
            overflow:hidden; 
            text-overflow:ellipsis;
            display:-webkit-box; 
            -webkit-box-orient:vertical;
            -webkit-line-clamp:2; 
            margin-top: .11rem;
            font-size: .15rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: .21rem;
        }
        
        .matchInfo{
            margin-top: .08rem;
            .matchs{
                 
                padding: .05rem .16rem .06rem .1rem;
                background: #F9F9F9;
                border-radius: .02rem;
                font-size: .12rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: .17rem;
                .match{
                   overflow: hidden; 
                   text-overflow: ellipsis;
                   white-space: nowrap;
                   width: 100%;
                   .tag{
                       margin-right: .05rem;
                       padding: 0 .04rem;
                       background: rgba(#2E9FFE,.06);
                       border-radius: .02rem;
                       font-size: .1rem;
                       font-family: PingFangSC-Regular, PingFang SC;
                       font-weight: 400;
                       color: #0078FF;
                       line-height: .14rem;
                   }
                }
                
                .numMatch{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    .tag{
                        margin-right: .05rem;
                        padding: 0 .04rem;
                        background: rgba(#2E9FFE,.06);
                        border-radius: .02rem;
                        font-size: .1rem;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #0078FF;
                        line-height: .14rem;
                    }
                    .right{
                        flex:1;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                }
            }
        }
        
        .Bottom{
            margin-top: .1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .time{
                font-size: .12rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: .17rem;
            }
            .priceBox{
                display: flex;
                align-items: center;
                .price{
                    font-size: .12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #F64646;
                    line-height: .17rem;
                }
                .VIPStyle {
                    margin-left: .05rem;
                    display: flex;
                    align-items: center;
                    color: #957160;
                    img {
                        width: .27rem;
                        height: .13rem;
                        margin-right: .01rem;
                    }
                    span{
                        white-space: nowrap;
                    }
                }
                .fenge{
                    margin: 0 .08rem;
                    width: .01rem;
                    height: .08rem;
                    background-color: #E6E6E6;
                }
                .tip{
                    font-size: .12rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #957160;
                    line-height: .17rem;
                }
            }
        }
    }
.xrzw{
    height: 0.35rem;
}
.xrjg{
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: .17rem;
    .left{
        font-size: .11rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: .16rem;
    }
    .right{
        display: flex;
        align-items: flex-end;
        width: 1.36rem;
        height: .3rem;
        background: url('../assets/images/xrbg.png') no-repeat;
        background-size: 100% 100%;
        padding: 0 0 .06rem .12rem;
        .text{
            font-size: .12rem;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            line-height: .18rem;
        }
        .num{
            font-size: .2rem;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 800;
            color: #FFE88F;
            line-height: .22rem;
        }
        .oldyuan{
            margin-left: .04rem;
            font-size: .12rem;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            color: #FFFFFF;
            line-height: .18rem;
            text-decoration: line-through;
        }
    }
}
</style>